import { NgModule } from '@angular/core';
import { HomeComponent } from './home.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/util/shared.module';
import { MatBadgeModule } from '@angular/material/badge';

const routes = [
  {
      path: 'home',
      component: HomeComponent
  }
];

@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    SharedModule,
    MatBadgeModule
  ],
  providers: [],
  exports: [
    HomeComponent
  ]
})
export class HomeModule { }
